<template>
  <div class="summary-container">
    <div class="text-muted mb-2">Ringkasan proyek aktif</div>
    <div class="summary-grid">
      <!-- Card 1: Nilai Kontrak (Primary Blue & Text Besar) -->
      <div class="summary-card card-hero-primary">
        <span class="card-label-hero">NILAI KONTRAK (BELUM PPN)</span>
        <span class="card-value-hero">
          {{ formatCurrency(summary.nilai_kontrak_belum_ppn) }}
        </span>
      </div>

      <!-- Card 2: Perencanaan Biaya (SPK vs SPH/Beban) -->
      <div class="summary-card">
        <div class="card-section">
          <div class="card-row-split">
            <div>
              <span class="card-label">Total SPK</span>
              <span class="card-value-medium">{{
                formatCurrency(summary.spk)
              }}</span>
            </div>
            <div class="text-right">
              <span class="card-label">Total beban (SPH)</span>
              <span class="card-value-medium text-muted-value">{{
                formatCurrency(summary.sph)
              }}</span>
            </div>
          </div>
        </div>

        <div class="card-footer-info">
          <span class="footer-label-large">Margin (SPK - SPH)</span>
          <span class="footer-value-large value-percentage">
            {{ summary.margin ? summary.margin.toFixed(1) : '0.0' }}%
          </span>
        </div>
      </div>

      <!-- Card 3: Realisasi Lapangan (Panjar vs Beban) -->
      <div class="summary-card">
        <div class="card-section">
          <div class="card-row-split">
            <div>
              <span class="card-label">Total panjar</span>
              <span class="card-value-medium">{{
                formatCurrency(summary.total_panjar)
              }}</span>
            </div>
            <div class="text-right">
              <span class="card-label">Total beban (SPH)</span>
              <span class="card-value-medium text-muted-value">{{
                formatCurrency(summary.sph)
              }}</span>
            </div>
          </div>
        </div>

        <!-- Bagian Bawah: Ukuran teks & angka diperbesar -->
        <div class="card-footer-info">
          <span class="footer-label-large">
            Selisih:
            <span :class="getSelisihClass(summary.sph - summary.total_panjar)">
              {{ formatCurrency(summary.sph - summary.total_panjar) }}
            </span>
          </span>
          <span class="footer-value-large value-percentage">
            {{
              summary.selisih_beban_panjar
                ? summary.selisih_beban_panjar.toFixed(2)
                : '0.00'
            }}%
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProjectSummary',
  props: {
    summary: {
      type: Object,
      default: () => ({
        nilai_kontrak_belum_ppn: 0,
        spk: 0,
        sph: 0,
        margin: 0,
        total_panjar: 0,
        selisih_beban_panjar: 0,
      }),
    },
  },
  methods: {
    formatCurrency(value) {
      if (value === undefined || value === null) return 'Rp0'
      const numericValue = Math.round(Number(value))
      return (
        'Rp' + numericValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      )
    },
    getSelisihClass(value) {
      if (value > 0) return 'text-success font-weight-bold'
      if (value < 0) return 'text-danger font-weight-bold'
      return 'font-weight-bold'
    },
  },
}
</script>

<style scoped>
.summary-container {
  margin-bottom: 1rem;
  width: 100%;
}

.summary-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1.5rem;
}

@media (max-width: 992px) {
  .summary-grid {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
}

/* Base Card Modern Flat */
.summary-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 1.25rem 1.5rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 120px; /* Sedikit dinaikkan agar proporsinya pas dengan teks bawah yang membesar */
  transition: all 0.2s ease;
}

.summary-card:hover {
  border-color: #cbd5e1;
}

/* --- CARD UTAMA BIRU PRIMARY --- */
.card-hero-primary {
  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
  border: none;
  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.15);
  justify-content: center;
  gap: 0.6rem;
}

.card-hero-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(37, 99, 235, 0.25);
}

.card-label-hero {
  display: block;
  font-size: 13px;
  font-weight: 700;
  color: rgba(255, 255, 255, 0.85);
  letter-spacing: 0.8px;
}

.card-value-hero {
  font-size: 26px;
  font-weight: 800;
  color: #ffffff;
  line-height: 1;
  white-space: nowrap;
}

/* --- STYLE CARD GABUNGAN --- */
.card-section {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.card-row-split {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 1.5rem;
}

.text-right {
  text-align: right;
}

.card-label {
  display: block;
  font-size: 11px;
  font-weight: 500;
  color: #64748b;
  margin-bottom: 0.4rem;
  letter-spacing: 0.3px;
}

.card-value-medium {
  font-size: 16px;
  font-weight: 700;
  color: #1e293b;
  white-space: nowrap;
}

.text-muted-value {
  color: #475569;
  font-weight: 600;
}

/* --- BAGIAN BAWAH YANG DIPERBESAR (UPDATED) --- */
.card-footer-info {
  border-top: 1px dashed #e2e8f0;
  margin-top: 1.25rem;
  padding-top: 0.85rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

/* Ukuran label teks bawah naik dari 11px ke 13px */
.footer-label-large {
  font-size: 13px;
  color: #475569;
  font-weight: 600;
}

/* Ukuran nilai data bawah naik dari 13px ke 15px */
.footer-value-large {
  font-size: 15px;
  font-weight: 700;
}

/* Aksen Warna */
.value-percentage {
  color: #0284c7;
}

.text-success {
  color: #16a34a;
}

.text-danger {
  color: #dc2626;
}

.font-weight-bold {
  font-weight: 700;
}
</style>
